export const Authendpoint={
    Login:"login",
    SignUp:"register",
    forgotPassword:"reset-password-request",
    resetPassword:"resetPassword",
    googleauth:"auth/google",
    googleVerify:"auth/google/verify",
    facebookverify:"auth/facebook/verify",
    facebookauth:"auth/facebook",
    updatePassword:"/updatePassword"
}